import Icon from '../components/Icon.vue'

Icon.register({
  compass: {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M225.4 233.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3c-12.5 12.5-32.8 12.5-45.3 0-12.5-12.5-12.5-32.8 0-45.3zM248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM374.1 156.1c7.6-16.6-9.5-33.8-26.2-26.2l-144.3 66c-6 2.7-13 9.8-15.8 15.8l-66 144.4c-7.6 16.6 9.5 33.8 26.2 26.2l144.3-66c6-2.7 13-9.8 15.8-15.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/compass.js
// module id = 1235
// module chunks = 0